module.exports = __webpack_public_path__ + "img/truck.e68dea64.svg";